export { default as HotelIcon } from './hotel.svg';
export { default as PlaneIcon } from './plane.svg';
export { default as TourIcon } from './tour.svg';
export { default as CruiseIcon } from './cruise.svg';
export { default as CarICon } from './car.svg';
